import React, { useMemo } from 'react';
import { map } from 'lodash';
import useT from '../../utils/Translations/useT';
import SelectBoxFilter from './SelectBoxFilter';
const PersonEntityRoleSelectorWithAll = ({ onChange, value, label, name, roles, }) => {
    const t = useT();
    const options = useMemo(() => map(roles, ({ id, name }) => ({
        id,
        value: name,
        name: t(name),
    })), [t, roles]);
    const optionsByValue = useMemo(() => options.reduce((obj, item) => {
        obj[item.value] = item;
        return obj;
    }, {}), [options]);
    const allOptions = {
        id: 0,
        name: t('All'),
        value: null,
    };
    const roleOptions = useMemo(() => [allOptions, { id: 0, divider: true }, ...options], [options]);
    const valueWithFallback = useMemo(() => {
        const valueWithFallback = value ? optionsByValue[value] : undefined;
        if (!value || !valueWithFallback) {
            return allOptions.value;
        }
        return valueWithFallback.value;
    }, [optionsByValue, value]);
    const title = useMemo(() => (label ? label : t('Role')), [t, label]);
    return (<SelectBoxFilter includeAll allOptions={allOptions} name={name} options={roleOptions} orderOptionsBy="id" title={title} value={valueWithFallback} onChange={onChange}/>);
};
export default PersonEntityRoleSelectorWithAll;
